<script setup lang="ts">
import { JSONToObject } from '@/TUIKit/utils';

interface CustomerExchangeExt {
    content?: string;
    exchangeInSessionId?: string;
    subType?: string;
    consultProblemTypes?: {
        code: string;
        desc: string;
        relationFlag: number;
    }[];
}

const props = defineProps<{
    data?: string | CustomerExchangeExt;
}>();

const exchangeData = computed<CustomerExchangeExt>(() => {
    if (!props.data) {
        return {};
    }

    if (typeof props.data !== 'string') {
        return props.data;
    }

    const data = JSONToObject(props.data);
    return typeof data === 'object' && data !== null ? data : {};
});

const messageContent = computed(() => exchangeData.value.content || '该咨询需转接客服处理');

const buttonText = computed(() => {
    if (exchangeData.value.subType === 'toPlat') {
        return '转接平台客服';
    }
    if (['toShop', 'toMerchant'].includes(exchangeData.value.subType || '')) {
        return '转接商家客服';
    }
    return '转接客服';
});
</script>

<template>
    <div class="customer-exchange-message">
        <div class="customer-exchange-message__content">
            {{ messageContent }}
        </div>
        <div class="customer-exchange-message__button">
            {{ buttonText }}
        </div>
        <div class="customer-exchange-message__footer">此消息由机器人发送</div>
    </div>
</template>

<style lang="scss" scoped>
.customer-exchange-message {
    width: min(320px, calc(100vw - 120px));
    max-width: 100%;
    line-height: 24px;

    &__content {
        color: #222222;
        font-size: 15px;
        word-break: break-word;
    }

    &__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        margin-top: 12px;
        padding: 0 14px;
        border-radius: 4px;
        background: #00b8d9;
        color: #ffffff;
        font-size: 15px;
        font-weight: 500;
        line-height: 32px;
        user-select: none;
    }

    &__footer {
        margin-top: 12px;
        color: #999999;
        font-size: 14px;
        line-height: 20px;
    }
}
</style>
